import { render } from "./HorizontalBarChartTable.vue?vue&type=template&id=9ba079dc"
import script from "./HorizontalBarChartTable.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChartTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__